export const manifest = {
  screens: {
    scr_v18pci: { name: "1 — Opening", route: "/", state: {"currentSlide":0}, position: {"x":160,"y":220} },
    scr_oal775: { name: "2 — Why This Matters", route: "/", state: {"currentSlide":1}, position: {"x":2960,"y":220} },
    scr_2rer3v: { name: "3 — The Bottleneck Principle", route: "/", state: {"currentSlide":2}, position: {"x":4360,"y":220} },
    scr_08x8bg: { name: "4 — The Congress Funnel Model", route: "/", state: {"currentSlide":3}, position: {"x":5760,"y":220} },
    scr_o8xvlk: { name: "5 — The Use Case Menu", route: "/", state: {"currentSlide":4}, position: {"x":7160,"y":220} },
    scr_v6q04p: { name: "6 — Price & Reuse Logic", route: "/", state: {"currentSlide":5}, position: {"x":8560,"y":220} },
    scr_c5wuol: { name: "7 — Recommended First Pilot", route: "/", state: {"currentSlide":6}, position: {"x":9960,"y":220} },
    scr_39ccqe: { name: "8 — What Takeda Gets", route: "/", state: {"currentSlide":7}, position: {"x":11360,"y":220} },
    scr_u9fiy1: { name: "9 — How Snakker Works With Agencies", route: "/", state: {"currentSlide":8}, position: {"x":12760,"y":220} },
    scr_agxxj0: { name: "10 — Deployment & Data Options", route: "/", state: {"currentSlide":9}, position: {"x":14160,"y":220} },
    scr_1fmy2r: { name: "11 — How To Choose The First Use Case", route: "/", state: {"currentSlide":10}, position: {"x":15560,"y":220} },
    scr_ne36xg: { name: "12 — Recommended Next Step", route: "/", state: {"currentSlide":11}, position: {"x":16960,"y":220} },
  },
  sections: {
    sec_ld7frp: { name: "Congress Pitch Flow", x: 0, y: 0, width: 18320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_ld7frp", children: [
      { kind: "screen", id: "scr_v18pci" },
      { kind: "screen", id: "scr_aj1s17" },
      { kind: "screen", id: "scr_oal775" },
      { kind: "screen", id: "scr_2rer3v" },
      { kind: "screen", id: "scr_08x8bg" },
      { kind: "screen", id: "scr_o8xvlk" },
      { kind: "screen", id: "scr_v6q04p" },
      { kind: "screen", id: "scr_c5wuol" },
      { kind: "screen", id: "scr_39ccqe" },
      { kind: "screen", id: "scr_u9fiy1" },
      { kind: "screen", id: "scr_agxxj0" },
      { kind: "screen", id: "scr_1fmy2r" },
      { kind: "screen", id: "scr_ne36xg" },
    ] },
  ],
}
